import styled from "styled-components";

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #EEF1F6;
    overflow: hidden;
`;

export const Content = styled.div`
    flex: 1;
    overflow-y: auto;
`;
